/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { ConnectApiKeyDailymotionAuthMutationRequest, ConnectApiKeyDailymotionAuthMutationResponse, ConnectApiKeyDailymotionAuthPathParams } from "../models/ConnectApiKeyDailymotionAuth";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { connectApiKeyDailymotionAuth } from "../axios/connectApiKeyDailymotionAuth";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const connectApiKeyDailymotionAuthMutationKey = () => ["social-export-api", { url: '/auth/dailymotion/api-key/:station' }] as const

export type ConnectApiKeyDailymotionAuthMutationKey = ReturnType<typeof connectApiKeyDailymotionAuthMutationKey>

export function connectApiKeyDailymotionAuthMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ConnectApiKeyDailymotionAuthMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = connectApiKeyDailymotionAuthMutationKey()
        return mutationOptions<ConnectApiKeyDailymotionAuthMutationResponse, ResponseErrorConfig<Error>, {station: ConnectApiKeyDailymotionAuthPathParams["station"], data: ConnectApiKeyDailymotionAuthMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ station, data }) => {
            return connectApiKeyDailymotionAuth(station, data, config)
          },
        })

}

/**
 * @summary Connect with Dailymotion using a private API key
 * {@link /auth/dailymotion/api-key/:station}
 */
export function useConnectApiKeyDailymotionAuth<TContext>(options: 
{
  mutation?: UseMutationOptions<ConnectApiKeyDailymotionAuthMutationResponse, ResponseErrorConfig<Error>, {station: ConnectApiKeyDailymotionAuthPathParams["station"], data: ConnectApiKeyDailymotionAuthMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ConnectApiKeyDailymotionAuthMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? connectApiKeyDailymotionAuthMutationKey()

          const baseOptions = connectApiKeyDailymotionAuthMutationOptions(config) as UseMutationOptions<ConnectApiKeyDailymotionAuthMutationResponse, ResponseErrorConfig<Error>, {station: ConnectApiKeyDailymotionAuthPathParams["station"], data: ConnectApiKeyDailymotionAuthMutationRequest}, TContext>
          

          return useMutation<ConnectApiKeyDailymotionAuthMutationResponse, ResponseErrorConfig<Error>, {station: ConnectApiKeyDailymotionAuthPathParams["station"], data: ConnectApiKeyDailymotionAuthMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ConnectApiKeyDailymotionAuthMutationResponse, ResponseErrorConfig<Error>, {station: ConnectApiKeyDailymotionAuthPathParams["station"], data: ConnectApiKeyDailymotionAuthMutationRequest}, TContext>
      
}